import { useEffect, useRef } from "react";
import { useConsent } from "../consent/useConsent";
import { initGTM, updateGTMConsent, setMetaPixelConsent } from "./gtm";

/**
 * AnalyticsLoader – bezskriptový komponent, ktorý sleduje zmeny súhlasu
 * a podľa toho inicializuje alebo deaktivuje tracking nástroje:
 *   - GTM Consent Mode v2 signály (aktualizované pri každej zmene)
 *   - GTM s Meta Pixelom (jediná značka v kontajneri – marketing súhlas)
 *
 * Analytický nástroj web zatiaľ nepoužíva. Keď sa GA4 pridá do GTM, načítaj
 * GTM aj po analytickom súhlase, GA4 značke nastav súhlas analytics_storage,
 * zvýš POLICY_VERSION a doplň GA4 do zásad Cookies a GDPR.
 *
 * Umiestni ho raz do stromu komponentov vnútri <ConsentProvider>.
 */
function AnalyticsLoader() {
  const { consent } = useConsent();
  const prevConsent = useRef(null);

  useEffect(() => {
    if (!consent) return;

    const prevStr = JSON.stringify(prevConsent.current);
    const currStr = JSON.stringify({
      analytics: consent.analytics,
      marketing: consent.marketing,
      preferences: consent.preferences,
    });
    if (prevStr === currStr) return;

    prevConsent.current = {
      analytics: consent.analytics,
      marketing: consent.marketing,
      preferences: consent.preferences,
    };

    // ── 1. GTM Consent Mode v2 – aktualizuj signály pri každej zmene ──
    updateGTMConsent({
      analytics: consent.analytics,
      marketing: consent.marketing,
      preferences: consent.preferences,
    });

    // ── 2. Meta Pixel Consent Mode nečíta – súhlas mu odovzdáme priamo ──
    setMetaPixelConsent(consent.marketing);

    // ── 3. GTM (načíta sa raz, len s marketingovým súhlasom) ──
    if (consent.marketing) {
      initGTM();
    }

  }, [consent]);

  return null;
}

export default AnalyticsLoader;
